import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=227a7bfe&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=227a7bfe&prod&lang=scss&scoped=true"
import style1 from "./Modal.vue?vue&type=style&index=1&id=227a7bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227a7bfe",
  null
  
)

export default component.exports